// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ck-z","articleImagesWrap":"dk-z","articleImage":"ek-z","singleImage":"fk-z"};